import { BrowserRouter } from 'react-router-dom';
import { ThemeWrapper } from 'sama-shared';
import { AdminRouter } from './routes/AdminRouter';

export default function App() {
  return (
    <ThemeWrapper>
      <BrowserRouter>
        <AdminRouter />
      </BrowserRouter>
    </ThemeWrapper>
  );
}
